import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Form } from 'formik';
import { Grid } from '@material-ui/core';

import { Alert, RemoveIcon, ValidatedTextField } from 'components';
import { IUpdateDepartmentLocation } from 'features/admin/types';

interface IProps {
  item: IUpdateDepartmentLocation;
  inputPlaceholderKey: string;
  confirmDeleteKey: string;
  onDelete: () => void;
}

const UpdateForm: FC<IProps> = props => {
  const [confirmOpen, setConfirmOpen] = useState(false);
  const { t } = useTranslation();

  const { confirmDeleteKey, inputPlaceholderKey, onDelete } = props;

  function toggleConfirm() {
    setConfirmOpen(!confirmOpen);
  }

  function renderAlert() {
    return (
      <Alert
        open={confirmOpen}
        onConfirm={() => {
          toggleConfirm();
          onDelete();
        }}
        onCancel={toggleConfirm}
        message={t(confirmDeleteKey)}
        confirm={t('common:delete')}
      />
    );
  }

  return (
    <Grid container component={Form} item alignItems="center">
      <Grid item xs={11}>
        <ValidatedTextField
          name="title"
          i18nKey={inputPlaceholderKey}
          color="primary"
          TextFieldProps={{ margin: 'none', label: null }}
        />
      </Grid>
      <Grid item xs={1}>
        <RemoveIcon onClick={toggleConfirm} />
      </Grid>
      {renderAlert()}
    </Grid>
  );
};

export default UpdateForm;
